/* eslint-disable class-methods-use-this, no-unused-expressions */
import RenderTime from 'utils/framework/performance/RenderTime';
import Stack from 'utils/framework/performance/Stack';
import Perf from 'utils/framework/Perf';

let _stack;
let _renderTime;
let _elementTiming;
let _hooks;

if (Sephora.isNodeRender) {
    if (Sephora.isIsomorphicBuild) {
        // to be able to use import statement in the node environment
        // we need to use experimental-modules flag
        _hooks = require('perf_hooks');
    }
}

class Performance {
    constructor() {
        _stack = new Stack();
        _renderTime = new RenderTime();

        // Only initialize ElementTimingTracker on client-side (browser)
        if (!Sephora.isNodeRender && typeof window !== 'undefined') {
            // Use early ElementTimingTracker initialized in head script
            // This ensures we don't lose elements that were already tracked before Performance.initialize()
            if (typeof Sephora !== 'undefined' && Sephora._earlyElementTiming) {
                _elementTiming = Sephora._earlyElementTiming;
                Sephora.logger.info('[Performance] Using ElementTimingTracker from head script (supported: ' + _elementTiming.isSupported + ')');
            } else {
                // Head script didn't initialize tracker (shouldn't happen in normal flow)
                Sephora.logger.warn('[Performance] ElementTimingTracker not initialized in head script');
                _elementTiming = {
                    expectElement: () => {},
                    clear: () => {},
                    setSpaNavigationStartTime: () => {},
                    disconnect: () => {},
                    isSupported: false
                };
            }
        } else {
            // Provide a dummy object for server-side rendering
            _elementTiming = {
                expectElement: () => {},
                clear: () => {},
                setSpaNavigationStartTime: () => {},
                disconnect: () => {},
                isSupported: false
            };
        }
    }

    get stack() {
        return _stack;
    }

    get renderTime() {
        return _renderTime;
    }

    get elementTiming() {
        return _elementTiming;
    }

    static initialize = () => {
        Sephora.performance = new Performance();
        Perf;
    };

    static now = () => {
        if (Sephora.isNodeRender) {
            if (Sephora.isIsomorphicBuild) {
                return _hooks.performance.now();
            } else {
                return global.window.performance.now();
            }
        } else {
            return window.performance.now();
        }
    };

    clear = () => {
        _stack.clear();
        _renderTime.clear();
        _elementTiming.clear();
    };
}

export default Performance;
